import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import Tabs from '../components/tabs';

interface TabsProcessorElement extends Element {
  props: Element['props'];
}

const tabs: Processor<TabsProcessorElement> = {
  priority: 10,
  name: 'tabs',
  test: ({ node }) => !!node.props?.className && node.props.className.includes('wp-block-erom-tabs'),
  processor: ({ node }) => {
    node.component = Tabs as ComponentType;

    return node;
  }
};

export default tabs;
